const removeAds = () => {
	const article = document.querySelector( '.article__content' );

	if ( ! article ) {
		return;
	}

	const articleAds = article.querySelectorAll( '.advert-wrapper' );

	article.querySelectorAll( '.advert-wrapper' ).forEach( advert => advert.remove() );
};

export const removeArticleAds = () => {
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', removeAds, { once: true } );
		return;
	}

	removeAds();
};

export default removeArticleAds;
